import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = (values = null) => ({
	labels: ['Retrasado', 'En progreso', 'No empezado', 'Terminado'],
	datasets: [
		{
			label: 'No. de tallas',
			data: [
				values.delayed,
				values.inProgres,
				values.notStarted,
				values.finished,
			],
			// data: [3, 5, 2, 3],
			backgroundColor: [
				'rgb(237, 22, 69, 1)',
				'rgba(54, 162, 235, 1)',
				'rgba(255, 206, 86, 1)',
				'rgba(75, 192, 192, 1)',
				// 'rgba(153, 102, 255, 1)',
				// 'rgba(255, 159, 64, 1)',
			],
			borderColor: [
				'rgba(255, 99, 132, 1)',
				'rgba(54, 162, 235, 1)',
				'rgba(255, 206, 86, 1)',
				'rgba(75, 192, 192, 1)',
				// 'rgba(153, 102, 255, 1)',
				// 'rgba(255, 159, 64, 1)',
			],
			borderWidth: 1,
		},
	],
});

const options = {
	responsive: true,
	plugins: {
		legend: {
			display: true,
			position: 'bottom',
		},
	},
};

export const PieChart = ({ values = null }) => {
	return <Pie data={data(values)} options={options} />;
};
